import { render, staticRenderFns } from "./confermaAccessoApp.vue?vue&type=template&id=553bf932&"
import script from "./confermaAccessoApp.vue?vue&type=script&lang=js&"
export * from "./confermaAccessoApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports